import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { usePreventBodyScrollByShow } from './hooks';

export default function Modal(props) {
  const {
    children,
    bodyId,
    header,
    show,
    close,
    closeClass,
    modalClass,
    headerClass,
    bodyClass,
    scrollElementRef,
    mobileTopHeader,
    footer,
    footerClass,
  } = props;
  usePreventBodyScrollByShow(show);

  return (
    <Dialog className="relative z-50" open={!!show} onClose={close}>
      <div
        className={`fixed inset-0 md:bg-primary-900/80 ${
          mobileTopHeader ? 'max-sm:!top-[69px] sm:max-md:!top-[91px]' : ''
        }`}
        aria-hidden="true"
      />
      <div
        className={`fixed inset-0 w-screen overflow-hidden ${
          mobileTopHeader ? 'max-sm:!top-[69px] sm:max-md:!top-[91px]' : ''
        }`}
      >
        <div className="flex min-h-full items-center justify-center md:px-6">
          <DialogPanel
            className={`flex flex-col mx-auto w-full max-w-[976px] md:rounded-10 overflow-hidden min-h-full bg-white max-md:h-[100dvh] md:max-h-[calc(100vh_-_128px)] ${modalClass} ${
              mobileTopHeader
                ? 'max-sm:!h-[calc(100dvh_-_69px)] sm:max-md:!h-[calc(100dvh_-_91px)]'
                : ''
            }`}
          >
            {header ? (
              <DialogTitle
                className={`w-full border-b border-slate-200 flex md:rounded-t-10 max-md:px-2 max-md:py-1 md:p-8 items-center md:justify-between ${
                  mobileTopHeader ? 'justify-between' : ''
                } ${headerClass}`}
              >
                {header}
                <button
                  type="button"
                  className={`float-right btn btn-icon max-sm:btn-sm max-md:order-1 ${
                    mobileTopHeader ? 'max-md:hidden' : ''
                  } ${closeClass}`}
                  onClick={close}
                  data-testid="modal-close-button"
                >
                  <i className="icon-arrow_alt_left text-primary-800 text-[24px] md:hidden" />
                  <i className="icon-close_round_small text-primary-800 text-[24px] max-md:hidden" />
                </button>
              </DialogTitle>
            ) : null}
            <div
              className={`max-md:px-6 md:pl-[46px] md:pr-10 md:mr-1.5 py-6 my-2 overflow-auto h-full scrollbar-thin scrollbar-thumb-slate-400 scrollbar-track-transparent scrollbar-thumb-rounded ${
                mobileTopHeader ? 'md:px-8' : ''
              } ${bodyClass}`}
              id={bodyId}
              ref={scrollElementRef}
            >
              {children}
            </div>
            {footer && (
              <div
                className={`!px-4 !py-3 sm:!px-10 bg-white border-t border-slate-300 justify-between items-end flex ${
                  mobileTopHeader ? 'md:px-8' : ''
                } ${footerClass} `}
              >
                {footer}
              </div>
            )}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
